import { useQuery } from 'react-query';

import { getProjectScoreCardsSummary as queryFn } from 'api/endPoints/getProjectScoreCardsSummary';
import { QueryKeys } from 'api/queryKeys';

export interface IPortfolioTopHeroesItems {
    name: string;
    order: number;
    value: number;
}

export interface IPortfolioTopHeroesComponentsList {
    [key: string]: IPortfolioTopHeroesItems[];
}

export interface IGetProjectScoreCardsSummary {
    componentsList: IPortfolioTopHeroesComponentsList;
    info?: IToolTip;
    name?: string;
}

export const useQueryProjectScoreCardsSummary = (params) => {
    return useQuery<IGetProjectScoreCardsSummary, QueryError, IGetProjectScoreCardsSummary, [QueryKeys, unknown]>({
        queryKey: ['projectScoreCardsSummary', params],
        queryFn: () => queryFn(params),
    });
};
